const LmsUrl = "https://alpha-v4-api.techsol360.com/";
const LmsAuthToken = "System123";
const LmsContentType = "application/json";

export const createStudentInLMS = async(studentData) => {
    try{
       const response = await fetch(`${LmsUrl}user/signup`,{
         method:'POST',
         headers:{
           'AuthToken':`${LmsAuthToken}`,
           'Content-Type': `${LmsContentType}`
         },
         body:JSON.stringify(studentData)
       });
       const student = await response.json();
       return student;
    }catch(error){
     console.error("Error Making Student In LMS.",error);
    }
 }; 
 export const Login = async (loginData) => {
  try{
    const response = await fetch(`${LmsUrl}user/login`,{
      method:'POST',
      headers:{
        'AuthToken':`${LmsAuthToken}`,
        'Content-Type':`${LmsContentType}`,
      },
      body:JSON.stringify(loginData)
    });
    const responseData = await response.json();
    if(responseData.payload && responseData.payload !== null){
    localStorage.setItem('token',responseData.payload.token);
    console.log(responseData.payload.token);
    return responseData;
    }else{
      return responseData;
    }
  }catch(err){
    console.error("Error While Login");
  }
};
 export const courseAccess = async (userId,productvariantId,expiresDate) => {
      try{
        const courseAccess= {
          userID:userId,
          productVariantID:productvariantId,
          expiresAt:new Date(expiresDate).toISOString(),
          allowedRanges:[]
        };
        const response = await fetch(`${LmsUrl}productvariant/user`,{
          method:'POST',
          headers:{
            'AuthToken':`${LmsAuthToken}`,
            'Content-Type':`${LmsContentType}`,
            'Authorization':`Bearer ${localStorage.getItem('token')}`
          },
          body:JSON.stringify(courseAccess)
        });
        if (response.status === 401) {
          return response.status;
        }
    
        const responseData = await response.json();
        console.log(responseData.payload);
      }catch(error){
        console.error("Error Accessing In Course.");
      }
 };
 export const invokedAccess = async (userId,productvariantId,status) =>{
    try{
      const invokeAccess ={
        userID:userId,
        productVariantID:productvariantId,
        status:status
      };
      const response = await fetch(`${LmsUrl}productvariant/user`,{
        method:'PUT',
        headers:{
          'AuthToken':`${LmsAuthToken}`,
          'Content-Type':`${LmsContentType}`,
          'Authorization':`Bearer ${localStorage.getItem('token')}`
        },
        body:JSON.stringify(invokeAccess)
      });
      if(response.status === 401){
        return response.status;
      }
      const responseData = await response.json();
      console.log(responseData.payload);
    }catch(error){
        console.error("Error Invoking In Course.");
      }
 };